export default {
    title_list: 'ArtiPro Memberships',
    title_page: 'ArtiPro Membership',
    title_create_page: 'Create ArtiPro Membership',
    title_edit_page: 'Change ArtiPro Membership',

    labels: {
        payments_table: 'Payments',
        card: 'Card',
        cost: 'Amount',
        braintree_id: 'Braintree ID',
        created_at: 'Date',
    },

    filter: {
        labels: {
            user_id: 'User',
            plan_id: 'Tariff plan',
            braintree_id: 'Braintree ID',
            active: 'Active',
            promo_code_id: 'Promo code',
            promo_code_renew_id: 'Promo code renew',
        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'User',
            company_id: 'Company',
            plan_id: 'Tariff plan',
            braintree_id: 'Braintree ID',
            price: 'Cost',
            payment: 'Payment',
            promoCode: 'Promo code',
            promoCodeRenew: 'Promo code renew',
            active: 'Active',
            startAt: 'Started At',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'User',
        plan_id: 'Tariff plan',
        braintree_id: 'Braintree ID',
        price: 'Cost',
        start_at: 'Date start',
        ends_at: 'Expiration date',
        active: 'Active',
        cancel: 'Cancel',
        cancel_at: 'Cancel date',
        company_id: 'Company',
    },
}
